import { makeStyles } from "@material-ui/core";

export const css = makeStyles(() => ({
    tableContainer: {
        width: "625px",
        margin: "16px 0",
    },
    tableHead: {
        background: "#f0f0f0",
    },
    tableHeadCell: {
        textAlign: "center",
        fontWeight: "bold",
    },
    tableHeadCellAlfa: {
        width: "130px",
        textAlign: "center",
        fontWeight: "bold",
    },
    tableRowCell: {
        textAlign: "center",
    },
    buttonRemover: {
        color: "green",
        fontWeight: "bold",
    },
}));
